'use client';
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    q: 'Is Operator Circle an investment company or fund manager?',
    a: 'No. Operator Circle is not an investment company, venture capital firm, broker, financial adviser or fund manager. We are an introduction network. We facilitate confidential introductions between qualified operators and private capital providers. We do not receive or hold investor funds, negotiate investment terms, or guarantee funding outcomes.',
  },
  {
    q: 'How does the introduction process work?',
    a: 'After your application is approved and your profile is complete, you submit a Connection Request detailing your business and capital requirements. Our team reviews your request, identifies suitable investors from our vetted network, and facilitates a formal confidential introduction. From that point, both parties engage directly.',
  },
  {
    q: 'Are there any upfront fees?',
    a: 'No. Operator Circle does not charge any upfront fees. Professional success fees become payable only after a successful investor introduction has been made. Full fee terms are provided at the time of approval.',
  },
  {
    q: 'How are investors vetted?',
    a: 'Every investor in our network has been personally reviewed by our team. We verify identity, investment capacity, track record and suitability before admitting any investor to the platform. Our investor database is never publicly visible.',
  },
  {
    q: 'Is my information kept confidential?',
    a: 'Absolutely. Your profile and business details are never shared publicly or with any third party without your explicit consent. All introductions are subject to our strict confidentiality obligations. The platform operates on an invitation-only basis.',
  },
  {
    q: 'How long does the review process take?',
    a: 'Access requests are typically reviewed within 3–5 business days. Connection requests are reviewed within 5–10 business days depending on the complexity of the matching requirements.',
  },
  {
    q: 'Who is responsible for legal and financial due diligence?',
    a: 'Both parties are fully responsible for conducting their own legal, financial and commercial due diligence. Operator Circle accepts no responsibility for negotiations, contracts, investment decisions, profits, losses or disputes between parties.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faqs" className="py-24 bg-secondary">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="section-label text-accent mb-3">Frequently Asked</p>
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">Questions</h2>
          <div className="divider-gold mx-auto" />
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqs?.map((faq, i) => (
            <div key={`faq-${i}`} className="card-elevated overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-6 text-left"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-foreground text-sm leading-snug">{faq?.q}</span>
                <ChevronDown
                  size={18}
                  className={`flex-shrink-0 text-muted-foreground transition-transform duration-200 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === i && (
                <div className="px-6 pb-6 fade-in">
                  <div className="h-px bg-border mb-4" />
                  <p className="text-muted-foreground text-sm leading-relaxed">{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}